/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { CollectionView } from 'backbone.marionette';

import PRTNRDeviceItemView from '../PRTNRDeviceItemView';
import MaintenanceDeviceItemView from '../MaintenanceDeviceItemView';
import VB0DeviceItemView from '../VB0DeviceItemView';
import OrderDeviceItemView from '../OrderDeviceItemView/OrderDeviceItemView';

// import tmplOrderDeviceCollectionView from './OrderDeviceCollectionView.hbs';

const OrderDeviceCollectionView = CollectionView.extend({
  className: 'order-device-collection-view',

  childView(item) {
    switch (item.get('formTypeId')) {
      case '2':
      case '13':
      case '14':
      case '15':
      case '22':
      case '23':
      case '24':
      case '25':
      case '26':
        return PRTNRDeviceItemView;
      case '4':
        return MaintenanceDeviceItemView;
      case '5':
      case '6':
      case '10':
      case '11':
      case '17':
        return OrderDeviceItemView;
      case '16':
      case '18':
      case '20':
      case '21':
        return VB0DeviceItemView;
    }
  }
});

export default OrderDeviceCollectionView;
